import React from "react";
import PropTypes from "prop-types";
import { OrderedMap } from "immutable";
import { Row, Col, Table, Button } from "antd";


function RenderParameterThreshold({ record }) {
    if(record.evaluation_condition === "one_of") {
        return record.parameter_threshold.join(",");
    }
    return record.parameter_threshold;
}

function RenderParameterAction() {
    return <Button type={"ghost"} icon={"caret-right"}></Button>;
}

const TABLE_COLUMNS = new OrderedMap({
    parameter_name: {
        key: "parameter_name",
        title: "Name",
        dataIndex: "parameter_name",
        width: 100
    },
    description: {
        key: "description",
        title: "Description",
        dataIndex: "description",
        width: 200
    },
    evaluation_condition: {
        key: "evaluation_condition",
        title: "Condition",
        dataIndex: "evaluation_condition",
        width: 100,
        render: _ => _.label,
    },
    parameter_threshold: {
        key: "parameter_threshold",
        title: "Threshold",
        dataIndex: "parameter_threshold",
        width: 100,
        render: (_, record) => RenderParameterThreshold({ record })
    },
    parameter_applicability: {
        key: "parameter_applicability",
        title: "Applicability",
        dataIndex: "parameter_applicability",
        width: 100
    },
    deviation_support_options: {
        key: "deviation_support_options",
        title: "Deviation Reasons",
        dataIndex: "deviation_support_options",
        width: 120
    },
    test_run_analysis: {
        key: "test",
        title: "Run",
        dataIndex: "test_run_analysis",
        width: 30,
        render: () => RenderParameterAction()
    }
});


const SAMPLE_DATASOURCE = [{
    id: 1,
    parameter_name: "Anchor",
    description: "Either one of the listed anchors",
    evaluation_condition: { label: "One of", value: "one_of" },
    parameter_threshold: ["Godrej Applicances"],
    parameter_applicability: "Mandatory",
    deviation_support_options: ["Only one of the options is added"]
}];








class CreditPolicy extends React.Component {

    state = {
        editing: false
    }


    toggleEditMode = mode => {
        this.setState({
            editing: mode
        });
    }

    getTitle = () => {
        if (this.state.editing) {
            return(
                <Row>
                    <Col span={24} >
                        <Row type={"flex"} justify={"end"}>
                            <Col style={{ padding: "0px 5px"}}>
                                <Button icon={"edit"} type={"default"} >
                                    Request Policy Parameter
                                </Button>
                            </Col>
                            <Col style={{ padding: "0px 5px"}}>
                                <Button icon={"caret-right"} type={"primary"} onClick={this.toggleEditMode.bind(null, false)}>
                                    Save
                                </Button>
                            </Col>
                        </Row>
                    </Col>
                </Row>
            );
        }
        return(
            <Row>
                <Col span={24} >
                    <Row type={"flex"} justify={"end"}>
                        <Col style={{ padding: "0px 5px"}}>
                            <Button icon={"edit"} type={"default"} onClick={this.toggleEditMode.bind(null, true)} >
                                Edit
                            </Button>
                        </Col>
                        <Col style={{ padding: "0px 5px"}}>
                            <Button icon={"caret-right"} type={"primary"}>
                                Run Back Test
                            </Button>
                        </Col>
                    </Row>
                </Col>
            </Row>
        );
    }


    render() {
        return (
            <Row>
                <Col>
                    <Table
                        title={this.getTitle}
                        size={"small"}
                        bordered={true}
                        columns={TABLE_COLUMNS.toList()}
                        dataSource={SAMPLE_DATASOURCE}
                        rowKey={"id"}
                        loading={false}
                        pagination={false}
                    />
                </Col>
            </Row>
        );
    }
}

CreditPolicy.propTypes = {
    route: PropTypes.object
};


export default CreditPolicy;